export default __webpack_public_path__ + "static/media/blog_banner.048b5c20.png";